import React, { useMemo } from "react";
import "./A1DeviceLimit.css";

const TVIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12.8663H7.33398V11.7999H0.666992V1.79993H15.334V11.7999H8.66699V12.8663H12.8535V14.2003H3V12.8663ZM2 3.13293V10.4669H14V3.13293H2Z" fill="#220046" />
  </svg>
);

const LaptopIcon = () => (
  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.22222 7.73056V0H13.4444V7.73056H1.22222ZM2.32222 6.63056H12.3444V1.1H2.32222V6.63056ZM9.16667 9.11778V8.50667H14.6667V9.71667H0V8.50667H5.5V9.11778H9.16667Z" fill="#220046" />
  </svg>
);

const MobileIcon = () => (
  <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 0H7V10H0V0ZM1 1.5H6V8H1V1.5ZM3.5 9.5C3.77614 9.5 4 9.27614 4 9C4 8.72386 3.77614 8.5 3.5 8.5C3.22386 8.5 3 8.72386 3 9C3 9.27614 3.22386 9.5 3.5 9.5Z" fill="#220046" />
  </svg>
);

const DEFAULT_DEVICES = [
  {
    id: "tv",
    label: "TV",
    aliases: ["tv", "television"],
    Icon: TVIcon,
  },
  {
    id: "laptop",
    label: "Laptop",
    aliases: ["laptop", "desktop", "web"],
    Icon: LaptopIcon,
  },
  {
    id: "mobile",
    label: "Mobile",
    aliases: ["mobile", "android mobile", "ios mobile", "phone", "android", "ios", "tablet"],
    Icon: MobileIcon,
  },
];

const parsePayload = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value === "object") return value;

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const getDeviceLimitTitle = (app) => {
  if (app?.deviceLimit !== undefined && app?.deviceLimit !== null) {
    return app.deviceLimit;
  }

  return "";
};

const normalizeDevice = (device) =>
  String(device || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const formatDevices = (devices) => {
  if (devices.length === 0) return DEFAULT_DEVICES.map((device) => device.label).join(", ");
  if (devices.length === 1) return devices[0].label;

  const labels = devices.map((device) => device.label);
  return `${labels.slice(0, -1).join(", ")} & ${labels[labels.length - 1]}`;
};

const getAvailableDevices = (limitedDevice) => {
  const limitedDevices = String(limitedDevice || "")
    .split(",")
    .map(normalizeDevice)
    .filter(Boolean);

  if (limitedDevices.length === 0) return DEFAULT_DEVICES;

  return DEFAULT_DEVICES.filter(
    (device) =>
      !device.aliases.some((alias) => {
        const normalizedAlias = normalizeDevice(alias);
        return limitedDevices.some(
          (limited) =>
            limited === normalizedAlias ||
            limited.includes(normalizedAlias) ||
            normalizedAlias.includes(limited)
        );
      })
  );
};

const DeviceIcons = ({ devices }) => (
  <span className="a1-device-limit-icons" aria-hidden="true">
    {devices.map(({ id, Icon }) => (
      <Icon key={id} />
    ))}
  </span>
);

const A1DeviceLimit = ({ item }) => {
  const data = useMemo(
    () => parsePayload(item?.text_data ?? item?.text, {}),
    [item?.text_data, item?.text]
  );


  if (!data?.appName) return null;

  const deviceCount = getDeviceLimitTitle(data);
  const devices = getAvailableDevices(data?.limitedDevice);
  const deviceText = formatDevices(devices);

  return (
    <div className="a1-device-limit-card volte-text">
      <div className="a1-device-limit-main">
        <div className="a1-device-limit-copy">
          <div className="a1-device-limit-heading">
            {data?.appLink && (
              <img
                className="a1-device-limit-logo"
                src={data.appLink}
                alt={data.appName}
              />
            )}
            <div className="a1-device-limit-name">
              {data.appName}
              {deviceCount !== "" && (
                <>
                  <span> - </span>
                  <span className="a1-device-limit-number">{deviceCount}</span>
                </>
              )}
            </div>
          </div>
          {devices.length > 0 && (
            <div className="a1-device-limit-subtext">
              <DeviceIcons devices={devices} />
              <span>Watch on {deviceText}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default A1DeviceLimit;
